import React from 'react';
import { Button, colors } from '@material-ui/core';
import Gradient from '../../images/gradient.jpg';
import { ReactComponent as Mailbox } from '../../images/nova/mailbox.svg';
import { bold } from '../../lib/utils';

type EnvelopeSentCardProps = {
  onDone: () => void;
  onSignNow: () => void;
  showSignNowBtn: boolean;
  /** Replaces the default Sign Now button, e.g. the in-person signer picker. */
  signNowButton?: React.ReactNode;
  showAutomatedReminders: boolean;
  children?: React.ReactNode;
};

export function EnvelopeSentCard({
  onDone,
  onSignNow,
  showSignNowBtn,
  signNowButton,
  showAutomatedReminders,
  children,
}: EnvelopeSentCardProps) {
  return (
    <>
      <img src={Gradient} className="absolute -mt-6 w-full h-10 -z-10" alt="" />
      <main className="relative z-0 p-16 w-full font-sans bg-white rounded-t-xl">
        <section className="flex flex-col items-center mx-auto max-sm:px-4 sm:max-w-5xl">
          <article className="flex gap-16 justify-evenly items-center w-full max-sm:flex-col">
            <Mailbox />

            <div className="basis-2/5">
              <h1 className="mb-3 text-3xl font-['proxima-nova']">Envelope Sent!</h1>
              <p className="text-lg leading-normal text-grey-800">
                Recipients receive an email when it&apos;s their turn to sign.
                {showAutomatedReminders ? (
                  <>
                    {' '}
                    If they don&apos;t sign within {bold('24 hours')}, we&apos;ll automatically send a reminder on your
                    behalf.
                  </>
                ) : null}
              </p>
            </div>

            <div className="flex space-x-4 max-sm:flex-col max-sm:space-x-0 max-sm:space-y-3 max-sm:w-full">
              {signNowButton
                ? signNowButton
                : showSignNowBtn && (
                    <Button
                      color="primary"
                      variant="contained"
                      tabIndex={0}
                      onClick={onSignNow}
                      data-spec="sign-now-button"
                      className="px-8 py-[26px] h-12 rounded-full text-lg max-sm:w-full"
                      style={{ background: `linear-gradient(to right, ${colors.purple[900]}, ${colors.blue[400]})` }}
                    >
                      Sign Now
                    </Button>
                  )}
              <Button
                color="primary"
                variant="outlined"
                onClick={onDone}
                data-spec="im-done-button"
                className="px-8 py-[26px] h-12 rounded-full text-lg max-sm:w-full"
              >
                I&apos;m Done
              </Button>
            </div>
          </article>

          {children}
        </section>
      </main>
    </>
  );
}
